import api from 'api';
import i18n from 'i18n';
import {synchronizationsTypes} from 'redux/synchronizations';
import {transactionsTypes} from 'redux/transactions';
import {Synchronization} from 'types/diplomat/transaction/Synchronization';
import {Transaction} from 'types/diplomat/transaction/Transaction';

export const transactionSynchronizationGetters = {
   Synchronization: {
      schema: Synchronization,
      label: i18n.t('Synchronization'),
      baseApi: api.synchronizations,

      api: api.synchronizationsUpdate,
      apiValidate: api.synchronizationValidate,
      reduxType: synchronizationsTypes.UPDATE_SYNCHRONIZATION,
      reduxValidateType: synchronizationsTypes.VALIDATE_SYNCHRONIZATION,

      apiRuNow: api.runNowSync,
      runNowIdName: 'synchronizationid',
      nameField: 'synchronizationName',
   },
   Transaction: {
      schema: Transaction,
      label: i18n.t('Transaction'),
      baseApi: api.transactions,

      api: api.transactionsUpdate,
      apiValidate: api.transactionValidate,
      reduxType: transactionsTypes.UPDATE_TRANSACTION,
      reduxValidateType: transactionsTypes.VALIDATE_TRANSACTION,

      apiRuNow: api.runnow,
      runNowIdName: 'transactionid',
      nameField: 'transactionName',
   },
};
